import { AfterViewInit, Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { PoNotificationService } from '@po-ui/ng-components';
import { ThemeStateService, ThemeType, UserReportStateService } from 'ats-ui-lib';
import { environment } from '../environments/environment';
import { ApplicantMetricsTrackService } from './root/applicant-metrics-track/applicant-metrics-track.service';
import { DatadogRumService } from './root/datadog-rum-service/datadog-rum.service';
import { HotJarService } from './root/hot-jar/hot-jar.service';
import { NavigationLoaderService } from './root/navigation-loader/navigation-loader.service';
import { GtmService } from './root/gtm/gtm.service';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'ngx-ats-applicant',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
  providers: [ApplicantMetricsTrackService],
  standalone: false,
  host: {
    translate: 'no',
  },
})
export class AppComponent implements OnInit, AfterViewInit {
  constructor(
    private notificationService: PoNotificationService,
    private router: Router,
    private themeStateService: ThemeStateService,
    private datadogRumService: DatadogRumService,
    private userReportStateService: UserReportStateService,
    private hotJarService: HotJarService,
    private navigationLoaderService: NavigationLoaderService,
    private readonly gtmService: GtmService,
  ) {}

  public async ngOnInit(): Promise<void> {
    this.themeStateService.init();
    this.themeStateService.setCurrentTheme(ThemeType.Default);
    this.userReportStateService.init();
    this.datadogRumService.init();
    this.router.initialNavigation();
    this.notificationService.setDefaultDuration(+environment.toasterDurationMs);
    this.navigationLoaderService.init();
    this.gtmService.init();
  }

  public ngAfterViewInit(): void {
    this.hotJarService.init();
  }
}
